import script from "./footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./footer.vue?vue&type=script&setup=true&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=6ea332ac&scoped=true&lang=less"

import exportComponent from "/Users/n0ts/Projects/IceCreamSearch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea332ac"]])

export default __exports__